import { AbstractTeaserList, BaseTeaserItem } from '../../../../Resources/Private/TypeScript/Components/AbstractTeaserList'
import { getElementChild, getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

class ProjectList extends AbstractTeaserList<BaseTeaserItem> {
  constructor(container: HTMLElement) {
    super(container, {
      apiUrl: `${container.dataset.apiUrl || ''}/projects`,
      containerSelector: 'project-list',
      itemsPerPage: 6,
      listSelector: 'project-list-items',
      templateSelector: 'project-item-template'
    })
  }

  protected createItem(project: BaseTeaserItem): HTMLElement | null {
    if (this.template === null) {
      return null
    }

    const item = this.template.content.firstElementChild?.cloneNode(true) as HTMLElement | null

    if (item === null) {
      return null
    }

    const picture = getElementChild(item, 'project-item-template-image')
    if (picture !== null) {
      this.updatePictureSources(picture, project)
    }

    const badge = getElementChild(item, 'project-item-template-badge')
    if (badge !== null && project.category !== null) {
      badge.className = `badge badge--${project.category.color}`
      badge.textContent = project.category.title
    }

    const link = getElementChild(item, 'project-item-template-link') as HTMLAnchorElement | null
    if (link !== null) {
      link.href = `${project.detailLink}/${project.slug}`
      link.textContent = project.teaserTitle || project.title
    }

    const text = getElementChild(item, 'project-item-template-text')
    if (text !== null) {
      text.textContent = this.truncateText(project.teaserText, 80)
    }

    return item
  }
}

const containers = getElements('project-list')
containers.forEach((container: HTMLElement): void => {
  new ProjectList(container)
})
